export default class CustomerBlock {
    companyId: number = 0;
    name: string = "";
    companyEmployeeId: string = "";
    reason: string = "";
}